function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0.0917030568 24 0.0917030568 24 24.0917031 0 24.0917031"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5546\\u54C1\\u7BA1\\u7406",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5BFC\\u822A",
  transform: "translate(-700.000000, -174.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-2",
  transform: "translate(652.000000, 160.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "tongbuziyuan-xc-",
  transform: "translate(48.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.4761892,8.78385153 C23.0778001,7.38765745 22.2996875,10.2641609 20.1418515,17.4133619 C19.8807977,17.4133619 19.6281019,17.3788384 19.387575,17.3141834 C17.3903785,16.8826055 15.89377,15.1062096 15.89377,12.9798952 C15.89377,10.5309782 17.8787336,8.54553421 20.3276186,8.54553421 C20.6756157,8.54553421 21.4524653,8.54553421 22.4761892,8.78385153 Z",
  id: "Fill-3",
  fill: "#696D82",
  opacity: 0.600000024,
  mask: "url(#mask-2)",
  transform: "translate(19.283351, 12.927518) scale(-1, 1) translate(-19.283351, -12.927518) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.8868763,7.22350218 C16.139738,7.22350218 18.7762795,9.86042795 18.7762795,13.1130335 C18.7762795,13.2975517 18.7678894,13.4803086 18.7512693,13.659575 L19.1155342,13.659575 C20.1433857,13.6594469 21.0932285,14.2077176 21.6072023,15.097869 C22.1212082,15.9881164 22.1212082,17.084818 21.6072023,17.9749374 C21.0932285,18.8652169 20.1433857,19.4134876 19.1155342,19.4133625 L6.14185153,19.4133625 C5.88079767,19.4133625 5.62810189,19.3788384 5.38757496,19.3141834 C3.39037846,18.8826055 1.89377001,17.1062096 1.89377001,14.9798952 C1.89377001,12.5309782 3.87873362,10.5455342 6.32761863,10.5455342 C6.67561572,10.5455342 7.01262959,10.5455342 7.47618923,10.7838515 C8.37860553,8.68956041 10.4614964,7.22350218 12.8868763,7.22350218 Z M12.0306933,11 C11.6593275,11 11.4736446,11.1982807 11.4736446,11.5948421 L11.4736446,11.5948421 L11.473,14.809 L10.510713,13.6270561 C10.2671751,13.3276962 10.0051545,13.3081339 9.72481459,13.5683692 C9.44463784,13.8285609 9.42631844,14.1081842 9.66997877,14.4075441 L9.66997877,14.4075441 L11.4972681,16.6521985 C11.5150162,16.6740038 11.5328608,16.6943245 11.5499581,16.7125671 C11.6144557,16.8298109 11.7198367,16.9034076 11.8678021,16.9326024 C12.0916775,17.0623485 12.3033357,17.0047572 12.5027546,16.7599001 L12.5027546,16.7599001 L14.3300031,14.515115 L14.3952528,14.4259411 C14.5674201,14.1601655 14.5273508,13.9101083 14.2750449,13.6758965 L14.2750449,13.6758965 L14.1915268,13.6062317 C13.9426142,13.4224152 13.7084775,13.4652031 13.4891464,13.734627 L13.4891464,13.734627 L12.587,14.842 L12.5877011,11.5948421 C12.5877011,11.1982807 12.4020182,11 12.0306933,11 Z",
  id: "\\u5F62\\u72B6\\u7ED3\\u5408",
  fill: "#696D82",
  mask: "url(#mask-2)"
})))));

var SvgItemSync = function SvgItemSync(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgItemSync, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/itemSync.38ff1c77.svg";
export { ForwardRef as ReactComponent };